import { createFileRoute } from '@tanstack/react-router';
import TemplateBuilder from 'features/templateBuilder';

export const Route = createFileRoute('/spaces/template')({
  component: TemplateBuilder,
});
